export class SearchInvoiceByCCSearchDto {
    CCType :string |undefined='';
    ccLast4: string = '';
    ccToken: string = '';
    isDeclined: boolean = false;
}